import { getTransitionShorthand } from "../foundations/transition";
var parts = ["drawer", "handle", "closeButton", "body"];
var baseStyleDrawer = {
  h: "full",
  w: "calc(100% - var(--sizes-8))",
  maxW: "md",
  pos: "fixed",
  top: 0,
  transition: getTransitionShorthand("transform", "ease-out", "slow"),
  overflow: "visible",
  boxShadow: "1px 0 4px 0 var(--colors-blackAlpha-300)",
  bg: "white",
  padding: 0,
  zIndex: "modal"
};
var baseStyleHandle = {
  padding: 1,
  pos: "fixed",
  zIndex: "docked",
  bg: "transparent",
  borderRadius: "none"
};
var baseStyleCloseButton = {
  padding: 1,
  zIndex: "docked",
  borderRadius: "none",
  top: 0,
  position: "absolute",
  w: 12,
  h: 12,
  textAlign: "center",
  fontSize: "2xl",
  pos: "fixed"
};
var baseStyleBody = {
  w: "100%",
  h: "100%",
  overflowY: "scroll",
  p: 0
};
var baseStyle = {
  drawer: baseStyleDrawer,
  body: baseStyleBody,
  handle: baseStyleHandle,
  closeButton: baseStyleCloseButton
};
var defaultProps = {
  variant: "left"
};
var variants = {
  left: () => ({
    drawer: {
      left: 0,
      transform: "translateX(-100%)"
    },
    closeButton: {
      right: "calc(-1 * var(--sizes-12))"
    }
  }),
  right: () => ({
    drawer: {
      right: 0,
      transform: "translateX(100%)"
    },
    closeButton: {
      left: "calc(-1 * var(--sizes-12))"
    }
  })
};
export default {
  parts,
  baseStyle,
  variants,
  defaultProps
};
//# sourceMappingURL=drawer.js.map